import { VolumeOffRounded, VolumeUpRounded } from "@mui/icons-material";
import { Box, Button } from "@mui/joy";

interface MuteButtonProps {
  muted: boolean;
  handleMute: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const MuteButton = ({ muted, handleMute }: MuteButtonProps) => {
  return (
    <Box sx={{
      position: "absolute",
      top: 0,
      right: 0,
    }}>
      <Button
        variant="outlined"
        size="sm"
        onClick={handleMute}
        sx={{
          m: 2,
          width: "40px",
          height: "40px",
          minWidth: "40px",
          minHeight: "40px",
          color: "rgba(238, 238, 238, 1)",
          borderRadius: "50%",
          borderColor: "transparent",
          backgroundColor: "rgba(20, 20, 30, 0.5)",
          "&:hover": {
            backgroundColor: "rgba(20, 20, 30, 0.8)",
          },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 0,
        }}
      >
        {muted ? <VolumeOffRounded /> : <VolumeUpRounded />}
      </Button>
    </Box>
  )
}

export default MuteButton;